import { Labels } from 'components/folders-and-labels';

/** @ngInject */
export default function labelsRouter($stateProvider) {
    const labelsState = {
        url: '/labels',
        views: {
            contentBody: {
                component: Labels.Component.selector
            }
        }
    };

    $stateProvider
        .state('main.folders-and-labels.labels', labelsState)
        .state('main.folders-and-labels.labels.label', {
            url: '/{labelId}',
            resolve: {
                /** @ngInject */
                label(LabelsApi, $stateParams) {
                    return LabelsApi.entity($stateParams.labelId).catch(() => null);
                }
            },
            /** @ngInject */
            onEnter(label, $state) { // eslint-disable-line consistent-return
                if (!label) {
                    return $state.target('main.folders-and-labels.labels');
                }
            },
            component: Labels.LabelDetails.selector
        });
}



// WEBPACK FOOTER //
// ./app/components/folders-and-labels/labels/labels.router.js